module.exports = __webpack_public_path__ + "static/media/graph-1.bde53e18.svg";